module.exports = __webpack_public_path__ + "img/bubble1-active.6b5e648f.svg";